import type {Nullable} from '../../utility-types';
import type {DateObj, DateTimeObj, NaiveDateTimeObj} from '../types';

import {not} from '../../conditionalUtils';
import {logger} from '../../logger';
import {isValidDateTimeString} from '../isValidDateTimeString';
import {DEFAULT_DATE_STRING} from '../utils';
import {processUtcOffset} from './processUtcOffset';

export const datetimeObjToISOString = (
  obj?: Nullable<DateObj | DateTimeObj | NaiveDateTimeObj | string>,
) => {
  if (typeof obj === 'string') {
    if (not(isValidDateTimeString(obj))) {
      return new Date(DEFAULT_DATE_STRING).toISOString();
    }

    return obj;
  }

  const isInvalidInput = !obj || !['date', 'datetime'].includes(obj._type);

  if (isInvalidInput) {
    return new Date(DEFAULT_DATE_STRING).toISOString();
  }

  if (obj._type === 'date') {
    return new Date(obj.year, obj.month - 1, obj.day).toISOString();
  }

  // 2011-10-10T14:48:00.000+09:00
  const {
    day = 1,
    hour = 0,
    microsecond = 0,
    minute = 0,
    month = 1,
    second = 0,
    utcoffset,
    year = 3000,
  } = obj;

  try {
    const isoDate = new Date(
      Date.UTC(year, month - 1, day, hour, minute, second, microsecond / 1000),
    ).toISOString();

    return processUtcOffset(isoDate, utcoffset);
  } catch (e) {
    if (e instanceof RangeError) {
      logger.error('Invalid DateTimeObject.');

      return new Date(DEFAULT_DATE_STRING).toISOString();
    }

    throw e;
  }
};
